export default {
  ratings: [],
  rating: null,
  loading: false,
}
